import api from "./interceptor";

async function Post(path, data) {
  const response = await api.post(path, data);
  return response.data;
}

async function Get(path) {
  const response = await api.get(path);
  return response.data;
}

// async function Put(path, data, token) {
//   let url = BASE_URL + path;
//   let response = await axios.put(url, data, {
//     headers: token
//       ? {
//         Accept: "multipart/form-data",
//         Authorization: `${token}`
//       }
//       : {
//         Accept: "application/json"
//       }
//   });

//   return response.data;
// }

// async function Delete(path, data, token) {
//   let url = BASE_URL + path;

//   let response = await axios.delete(url, {
//     headers: token
//       ? {
//         Accept: "multipart/form-data",
//         Authorization: `Bearer ${token}`
//       }
//       : {
//         Accept: "application/json"
//       }
//   });

//   return response.data;
// }

// async function Patch(path, data, token) {
//   let url = BASE_URL + path;
//   let response = await axios.patch(url, data, {
//     headers: token
//       ? {
//         Accept: "multipart/form-data",
//         Authorization: `${token}`
//       }
//       : {
//         Accept: "application/json"
//       }
//   });

//   return response.data;
// }
// Put, Delete, Patch 
export { Post, Get, };
